import React from "react";
import { Backdrop, Dialog, makeStyles } from "@material-ui/core";
import { OrderDetailsForm } from "../../form";

const useStyle = makeStyles(theme => ({
  dialog: {
    maxWidth: "none"
  }
}))

export default function RedeemItemDialogComponent({
  isOpen,
  handleClose
}) {
  const classes = useStyle();
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
      closeAfterTransition
      BackdropComponent={Backdrop}
      maxWidth="sm"
      classes={{
        paperWidthSm: classes.dialog
      }}
    >
      <OrderDetailsForm
        handleClose={handleClose}
      />
    </Dialog>
  )
}
